import axios from 'axios';
import FileSaver from 'file-saver';
import { useState } from 'react';

import { useGetReportDownloadUrlLazyQueryGQLType } from '../requests/reports.gql.generated';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';

export const useReportDownloadUrl = ({
  toast,
  reportId,
  reportName,
  isDomainReport = false,
}: {
  toast: any;
  reportId: string;
  reportName: string;
  isDomainReport: boolean;
}) => {
  // loading state used here because loading prop of useLazyQuery does not continue to be true through awaiting the onCompleted step, resulting in the loading spinner for the download button only appearing for a split second
  const [loading, setLoading] = useState(false);
  const [
    _getReportDownloadUrl,
    { error },
  ] = useGetReportDownloadUrlLazyQueryGQLType({
    variables: { reportId, isDomainReport },
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data && data.reportDownloadUrl) {
        const { reportDownloadUrl } = data;
        axios({
          url: reportDownloadUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            const fileBlob = new Blob([response.data], {
              type: response.data.type,
            });
            FileSaver.saveAs(fileBlob, reportName);
            setLoading(false);
          })
          .catch((err) => {
            if (!toast.isActive(errorToastId)) {
              errorToastConfig.title = `Error downloading report ${reportName}`;
              toast(errorToastConfig);
            }
            throw err;
          });
      }
    },
  });

  return {
    getReportDownloadUrl: () => {
      setLoading(true);
      return _getReportDownloadUrl();
    },
    error,
    loading,
  };
};
